// Lund browder body part lists

const lundBrowderBase = {
  Neck_M_Anterior:{
    display: 'Neck, Anterior',
    code: 'Neck_M_Anterior',
    area: '1',
  },
  Neck_M_Posterior:{
    display: 'Neck, Posterior',
    code: 'Neck_M_Posterior',
    area: '1',
  },
  Neck_M_Left:{
    display: 'Neck, Left View',
    code: 'Neck_M_Left',
    area: '1',
  },
  Neck_M_Right:{
    display: 'Neck, Right View',
    code: 'Neck_M_Right',
    area: '1',
  },
  Torso_M_Anterior: {
    display: 'Torso, Anterior',
    code: 'Torso_M_Anterior',
    area: '3',
  },
  Torso_M_Posterior: {
    display: 'Torso, Posterior',
    code: 'Torso_M_Posterior',
    area: '3',
  },
  Torso_M_Left: {
    display: 'Torso, Left View',
    code: 'Torso_M_Left',
    area: '3',
  },
  Torso_M_Right: {
    display: 'Torso, Right View',
    code: 'Torso_M_Right',
    area: '3',
  },
  TorsoUpper_R_Anterior: {
    display: 'Torso, Upper Right Side, Anterior',
    code: 'TorsoUpper_R_Anterior',
    area: '3.25',
  },
  TorsoUpper_R_Posterior: {
    display: 'Torso, Upper Right Side, Posterior',
    code: 'TorsoUpper_R_Posterior',
    area: '3.25',
  },
  TorsoUpper_R_Right:{
    display: 'Torso, Upper Right Side, Right View',
    code: 'TorsoUpper_R_Right',
    area: '3.25',
  },
  TorsoUpper_L_Anterior: {
    display: 'Torso, Upper Left Side, Anterior',
    code: 'TorsoUpper_L_Anterior',
    area: '3.25',
  },
  TorsoUpper_L_Posterior: {
    display: 'Torso, Upper Left Side, Posterior',
    code: 'TorsoUpper_L_Posterior',
    area: '3.25',
  },
  TorsoUpper_L_Left: {
    display: 'Torso, Upper Left Side, Left View',
    code: 'TorsoUpper_L_Left',
    area: '3.25',
  },
  TorsoLower_R_Anterior: {
    display: 'Torso, Lower Right Side, Anterior',
    code: 'TorsoLower_R_Anterior',
    area: '3.25',
  },
  TorsoLower_R_Posterior: {
    display: 'Torso, Lower Right Side, Posterior',
    code: 'TorsoLower_R_Posterior',
    area: '3.25',
  },
  TorsoLower_R_Right: {
    display: 'Torso, Lower Right Side, Right View',
    code: 'TorsoLower_R_Right',
    area: '3.25',
  },
  TorsoLower_L_Anterior: {
    display: 'Torso, Lower Left Side, Anterior',
    code: 'TorsoLower_L_Anterior',
    area: '3.25',
  },
  TorsoLower_L_Posterior: {
    display: 'Torso, Lower Left Side, Posterior',
    code: 'TorsoLower_L_Posterior',
    area: '3.25',
  },
  TorsoLower_L_Left: {
    display: 'Torso, Lower Left Side, Left View',
    code: 'TorsoLower_L_Left',
    area: '3.25',
  },
  ArmUpper_R_Anterior:{
    display: 'Arm, Upper Right, Anterior',
    code: 'ArmUpper_R_Anterior',
    area: '2',
  },
  ArmUpper_R_Posterior: {
    display: 'Arm, Upper Right, Posterior',
    code: 'ArmUpper_R_Posterior',
    area: '2',
  },
  ArmUpper_R_Medial:{
    display: 'Arm, Upper Right, Medial',
    code: 'ArmUpper_R_Medial',
    area: '2',
  },
  ArmUpper_R_Lateral: {
    display: 'Arm, Upper Right, Lateral',
    code: 'ArmUpper_R_Lateral',
    area: '2',
  },
  ArmUpper_L_Anterior:{
    display: 'Arm, Upper Left, Anterior',
    code: 'ArmUpper_L_Anterior',
    area: '2',
  },
  ArmUpper_L_Posterior: {
    display: 'Arm, Upper Left, Posterior',
    code: 'ArmUpper_L_Posterior',
    area: '2',
  },
  ArmUpper_L_Medial:{
    display: 'Arm, Upper Left, Medial',
    code: 'ArmUpper_L_Medial',
    area: '2',
  },
  ArmUpper_L_Lateral:{
    display: 'Arm, Upper Left, Lateral',
    code: 'ArmUpper_L_Lateral',
    area: '2',
  },
  ArmLower_R_Anterior:{
    display: 'Arm, Lower Right, Anterior',
    code: 'ArmLower_R_Anterior',
    area: '1.5',
  },
  ArmLower_R_Posterior: {
    display: 'Arm, Lower Right, Posterior',
    code: 'ArmLower_R_Posterior',
    area: '1.5',
  },
  ArmLower_R_Medial:{
    display: 'Arm, Lower Right, Medial',
    code: 'ArmLower_R_Medial',
    area: '1.5',
  },
  ArmLower_R_Lateral:{
    display: 'Arm, Lower Right, Lateral',
    code: 'ArmLower_R_Lateral',
    area: '1.5',
  },
  ArmLower_L_Anterior:{
    display: 'Arm, Lower Left, Anterior',
    code: 'ArmLower_L_Anterior',
    area: '1.5',
  },
  ArmLower_L_Posterior: {
    display: 'Arm, Lower Left, Posterior',
    code: 'ArmLower_L_Posterior',
    area: '1.5',
  },
  ArmLower_L_Medial:{
    display: 'Arm, Lower Left, Medial',
    code: 'ArmLower_L_Medial',
    area: '1.5',
  },
  ArmLower_L_Lateral:{
    display: 'Arm, Lower Left, Lateral',
    code: 'ArmLower_L_Lateral',
    area: '1.5',
  },
  Hand_R_Palmar:{
    display: 'Hand, Right, Palmar',
    code: 'Hand_R_Palmar',
    area: '1.5',
  },
  Hand_R_Dorsal:{
    display: 'Hand, Right, Dorsal',
    code: 'Hand_R_Dorsal',
    area: '1.5',
  },
  Hand_L_Palmar:{
    display: 'Hand, Left, Palmar',
    code: 'Hand_L_Palmar',
    area: '1.5',
  },
  Hand_L_Dorsal:{
    display: 'Hand, Left, Dorsal',
    code: 'Hand_L_Dorsal',
    area: '1.5',
  },
  Genitalia_M_Anterior: {
    display: 'Genitalia, Anterior View',
    code: 'Genitalia_M_Anterior',
    area: '1',
  },
  Genitalia_M_Inferior: {
    display: 'Genitalia, Inferior View',
    code: 'Genitalia_M_Inferior',
    area: '1',
  },
  Buttock_R_Posterior:{
    display: 'Buttock, Right, Posterior',
    code: 'Buttock_R_Posterior',
    area: '2.5',
  },
  Buttock_L_Posterior:{
    display: 'Buttock, Left, Posterior',
    code: 'Buttock_L_Posterior',
    area: '2.5',
  },
  Foot_R_Superior:{
    display: 'Foot, Right, Dorsal',
    code: 'Foot_R_Superior',
    area: '1.75',
  },
  Foot_R_Inferior:{
    display: 'Foot, Right, Plantar',
    code: 'Foot_R_Inferior',
    area: '1.75',
  },
  Foot_R_Medial:{
    display: 'Foot, Right, Medial',
    code: 'Foot_R_Medial',
    area: '1.75',
  },
  Foot_R_Lateral:{
    display: 'Foot, Right, Lateral',
    code: 'Foot_R_Lateral',
    area: '1.75',
  },
  Foot_L_Superior:{
    display: 'Foot, Left, Dorsal',
    code: 'Foot_L_Superior',
    area: '1.75',
  },
  Foot_L_Inferior:{
    display: 'Foot, Left, Plantar',
    code: 'Foot_L_Inferior',
    area: '1.75',
  },
  Foot_L_Medial:{
    display: 'Foot, Left, Medial',
    code: 'Foot_L_Medial',
    area: '1.75',
  },
  Foot_L_Lateral:{
    display:'Foot, Left, Lateral',
    code: 'Foot_L_Lateral',
    area: '1.75',
  }
};
const infant = {
  Head_M_Anterior:{
    display: 'Head, Anterior',
    code: 'Head_M_Anterior',
    area: '9.5',
  },
  Head_M_Posterior:{
    display: 'Head, Posterior',
    code: 'Head_M_Posterior',
    area: '9.5',
  },
  Head_M_Left:{
    display: 'Head, Left',
    code: 'Head_M_Left',
    area: '9.5',
  },
  Head_M_Right:{
    display: 'Head, Right',
    code: 'Head_M_Right',
    area: '9.5',
  },
  Head_M_Superior:{
    display: 'Head, Superior',
    code: 'Head_M_Superior',
    area: '9.5',
  },
  Thigh_R_Anterior:{
    display: 'Thigh, Right, Anterior',
    code: 'Thigh_R_Anterior',
    area: '2.75',
  },
  Thigh_R_Posterior:{
    display: 'Thigh, Right, Posterior',
    code: 'Thigh_R_Posterior',
    area: '2.75',
  },
  Thigh_R_Medial:{
    display: 'Thigh, Right, Medial',
    code: 'Thigh_R_Medial',
    area: '2.75',
  },
  Thigh_R_Lateral:{
    display: 'Thigh, Right, Lateral',
    code: 'Thigh_R_Lateral',
    area: '2.75',
  },
  Thigh_L_Anterior:{
    display: 'Thigh, Left, Anterior',
    code: 'Thigh_L_Anterior',
    area: '2.75',
  },
  Thigh_L_Posterior:{
    display: 'Thigh, Left, Posterior',
    code: 'Thigh_L_Posterior',
    area: '2.75',
  },
  Thigh_L_Medial:{
    display: 'Thigh, Left, Medial',
    code: 'Thigh_L_Medial',
    area: '2.75',
  },
  Thigh_L_Lateral:{
    display: 'Thigh, Left, Lateral',
    code: 'Thigh_L_Lateral',
    area: '2.75',
  },
  Calf_R_Anterior:{
    display: 'Calf, Right, Anterior',
    code: 'Calf_R_Anterior',
    area: '2.5',
  },
  Calf_R_Posterior:{
    display: 'Calf, Right, Posterior',
    code: 'Calf_R_Posterior',
    area: '2.5',
  },
  Calf_R_Medial:{
    display: 'Calf, Right, Medial',
    code: 'Calf_R_Medial',
    area: '2.5',
  },
  Calf_R_Lateral:{
    display: 'Calf, Right, Lateral',
    code: 'Calf_R_Lateral',
    area: '2.5',
  },
  Calf_L_Anterior:{
    display: 'Calf, Left, Anterior',
    code: 'Calf_L_Anterior',
    area: '2.5',
  },
  Calf_L_Posterior:{
    display: 'Calf, Left, Posterior',
    code: 'Calf_L_Posterior',
    area: '2.5',
  },
  Calf_L_Medial:{
    display: 'Calf, Left, Medial',
    code: 'Calf_L_Medial',
    area: '2.5',
  },
  Calf_L_Lateral:{
    display: 'Calf, Left, Lateral',
    code: 'Calf_L_Lateral',
    area: '2.5',
  },
};
const toddler = {
  Head_M_Anterior:{
    display: 'Head, Anterior',
    code: 'Head_M_Anterior',
    area: '8.5',
  },
  Head_M_Posterior:{
    display: 'Head, Posterior',
    code: 'Head_M_Posterior',
    area: '8.5',
  },
  Head_M_Left:{
    display: 'Head, Left',
    code: 'Head_M_Left',
    area: '8.5',
  },
  Head_M_Right:{
    display: 'Head, Right',
    code: 'Head_M_Right',
    area: '8.5',
  },
  Head_M_Superior:{
    display: 'Head, Superior',
    code: 'Head_M_Superior',
    area: '8.5',
  },
  Thigh_R_Anterior:{
    display: 'Thigh, Right, Anterior',
    code: 'Thigh_R_Anterior',
    area: '3.25',
  },
  Thigh_R_Posterior:{
    display: 'Thigh, Right, Posterior',
    code: 'Thigh_R_Posterior',
    area: '3.25',
  },
  Thigh_R_Medial:{
    display: 'Thigh, Right, Medial',
    code: 'Thigh_R_Medial',
    area: '3.25',
  },
  Thigh_R_Lateral:{
    display: 'Thigh, Right, Lateral',
    code: 'Thigh_R_Lateral',
    area: '3.25',
  },
  Thigh_L_Anterior:{
    display: 'Thigh, Left, Anterior',
    code: 'Thigh_L_Anterior',
    area: '3.25',
  },
  Thigh_L_Posterior:{
    display: 'Thigh, Left, Posterior',
    code: 'Thigh_L_Posterior',
    area: '3.25',
  },
  Thigh_L_Medial:{
    display: 'Thigh, Left, Medial',
    code: 'Thigh_L_Medial',
    area: '3.25',
  },
  Thigh_L_Lateral:{
    display: 'Thigh, Left, Lateral',
    code: 'Thigh_L_Lateral',
    area: '3.25',
  },
  Calf_R_Anterior:{
    display: 'Calf, Right, Anterior',
    code: 'Calf_R_Anterior',
    area: '2.5',
  },
  Calf_R_Posterior:{
    display: 'Calf, Right, Posterior',
    code: 'Calf_R_Posterior',
    area: '2.5',
  },
  Calf_R_Medial:{
    display: 'Calf, Right, Medial',
    code: 'Calf_R_Medial',
    area: '2.5',
  },
  Calf_R_Lateral:{
    display: 'Calf, Right, Lateral',
    code: 'Calf_R_Lateral',
    area: '2.5',
  },
  Calf_L_Anterior:{
    display: 'Calf, Left, Anterior',
    code: 'Calf_L_Anterior',
    area: '2.5',
  },
  Calf_L_Posterior:{
    display: 'Calf, Left, Posterior',
    code: 'Calf_L_Posterior',
    area: '2.5',
  },
  Calf_L_Medial:{
    display: 'Calf, Left, Medial',
    code: 'Calf_L_Medial',
    area: '2.5',
  },
  Calf_L_Lateral:{
    display: 'Calf, Left, Lateral',
    code: 'Calf_L_Lateral',
    area: '2.5',
  },
};
const child = {
  Head_M_Anterior:{
    display: 'Head, Anterior',
    code: 'Head_M_Anterior',
    area: '6.5',
  },
  Head_M_Posterior:{
    display: 'Head, Posterior',
    code: 'Head_M_Posterior',
    area: '6.5',
  },
  Head_M_Left:{
    display: 'Head, Left',
    code: 'Head_M_Left',
    area: '6.5',
  },
  Head_M_Right:{
    display: 'Head, Right',
    code: 'Head_M_Right',
    area: '6.5',
  },
  Head_M_Superior:{
    display: 'Head, Superior',
    code: 'Head_M_Superior',
    area: '6.5',
  },
  Thigh_R_Anterior:{
    display: 'Thigh, Right, Anterior',
    code: 'Thigh_R_Anterior',
    area: '4',
  },
  Thigh_R_Posterior:{
    display: 'Thigh, Right, Posterior',
    code: 'Thigh_R_Posterior',
    area: '4',
  },
  Thigh_R_Medial:{
    display: 'Thigh, Right, Medial',
    code: 'Thigh_R_Medial',
    area: '4',
  },
  Thigh_R_Lateral:{
    display: 'Thigh, Right, Lateral',
    code: 'Thigh_R_Lateral',
    area: '4',
  },
  Thigh_L_Anterior:{
    display: 'Thigh, Left, Anterior',
    code: 'Thigh_L_Anterior',
    area: '4',
  },
  Thigh_L_Posterior:{
    display: 'Thigh, Left, Posterior',
    code: 'Thigh_L_Posterior',
    area: '4',
  },
  Thigh_L_Medial:{
    display: 'Thigh, Left, Medial',
    code: 'Thigh_L_Medial',
    area: '4',
  },
  Thigh_L_Lateral:{
    display: 'Thigh, Left, Lateral',
    code: 'Thigh_L_Lateral',
    area: '4',
  },
  Calf_R_Anterior:{
    display: 'Calf, Right, Anterior',
    code: 'Calf_R_Anterior',
    area: '2.75',
  },
  Calf_R_Posterior:{
    display: 'Calf, Right, Posterior',
    code: 'Calf_R_Posterior',
    area: '2.75',
  },
  Calf_R_Medial:{
    display: 'Calf, Right, Medial',
    code: 'Calf_R_Medial',
    area: '2.75',
  },
  Calf_R_Lateral:{
    display: 'Calf, Right, Lateral',
    code: 'Calf_R_Lateral',
    area: '2.75',
  },
  Calf_L_Anterior:{
    display: 'Calf, Left, Anterior',
    code: 'Calf_L_Anterior',
    area: '2.75',
  },
  Calf_L_Posterior:{
    display: 'Calf, Left, Posterior',
    code: 'Calf_L_Posterior',
    area: '2.75',
  },
  Calf_L_Medial:{
    display: 'Calf, Left, Medial',
    code: 'Calf_L_Medial',
    area: '2.75',
  },
  Calf_L_Lateral:{
    display: 'Calf, Left, Lateral',
    code: 'Calf_L_Lateral',
    area: '2.75',
  },
};
const teenager = {
  Head_M_Anterior:{
    display: 'Head, Anterior',
    code: 'Head_M_Anterior',
    area: '5.5',
  },
  Head_M_Posterior:{
    display: 'Head, Posterior',
    code: 'Head_M_Posterior',
    area: '5.5',
  },
  Head_M_Left:{
    display: 'Head, Left',
    code: 'Head_M_Left',
    area: '5.5',
  },
  Head_M_Right:{
    display: 'Head, Right',
    code: 'Head_M_Right',
    area: '5.5',
  },
  Head_M_Superior:{
    display: 'Head, Superior',
    code: 'Head_M_Superior',
    area: '5.5',
  },
  Thigh_R_Anterior:{
    display: 'Thigh, Right, Anterior',
    code: 'Thigh_R_Anterior',
    area: '4.25',
  },
  Thigh_R_Posterior:{
    display: 'Thigh, Right, Posterior',
    code: 'Thigh_R_Posterior',
    area: '4.25',
  },
  Thigh_R_Medial:{
    display: 'Thigh, Right, Medial',
    code: 'Thigh_R_Medial',
    area: '4.25',
  },
  Thigh_R_Lateral:{
    display: 'Thigh, Right, Lateral',
    code: 'Thigh_R_Lateral',
    area: '4.25',
  },
  Thigh_L_Anterior:{
    display: 'Thigh, Left, Anterior',
    code: 'Thigh_L_Anterior',
    area: '4.25',
  },
  Thigh_L_Posterior:{
    display: 'Thigh, Left, Posterior',
    code: 'Thigh_L_Posterior',
    area: '4.25',
  },
  Thigh_L_Medial:{
    display: 'Thigh, Left, Medial',
    code: 'Thigh_L_Medial',
    area: '4.25',
  },
  Thigh_L_Lateral:{
    display: 'Thigh, Left, Lateral',
    code: 'Thigh_L_Lateral',
    area: '4.25',
  },
  Calf_R_Anterior:{
    display: 'Calf, Right, Anterior',
    code: 'Calf_R_Anterior',
    area: '3',
  },
  Calf_R_Posterior:{
    display: 'Calf, Right, Posterior',
    code: 'Calf_R_Posterior',
    area: '3',
  },
  Calf_R_Medial:{
    display: 'Calf, Right, Medial',
    code: 'Calf_R_Medial',
    area: '3',
  },
  Calf_R_Lateral:{
    display: 'Calf, Right, Lateral',
    code: 'Calf_R_Lateral',
    area: '3',
  },
  Calf_L_Anterior:{
    display: 'Calf, Left, Anterior',
    code: 'Calf_L_Anterior',
    area: '3',
  },
  Calf_L_Posterior:{
    display: 'Calf, Left, Posterior',
    code: 'Calf_L_Posterior',
    area: '3',
  },
  Calf_L_Medial:{
    display: 'Calf, Left, Medial',
    code: 'Calf_L_Medial',
    area: '3',
  },
  Calf_L_Lateral:{
    display: 'Calf, Left, Lateral',
    code: 'Calf_L_Lateral',
    area: '3',
  },
};
const adult = {
  Head_M_Anterior:{
    display: 'Head, Anterior',
    code: 'Head_M_Anterior',
    area: '4.5',
  },
  Head_M_Posterior:{
    display: 'Head, Posterior',
    code: 'Head_M_Posterior',
    area: '4.5',
  },
  Head_M_Left:{
    display: 'Head, Left',
    code: 'Head_M_Left',
    area: '4.5',
  },
  Head_M_Right:{
    display: 'Head, Right',
    code: 'Head_M_Right',
    area: '4.5',
  },
  Head_M_Superior:{
    display: 'Head, Superior',
    code: 'Head_M_Superior',
    area: '4.5',
  },
  Thigh_R_Anterior:{
    display: 'Thigh, Right, Anterior',
    code: 'Thigh_R_Anterior',
    area: '4.5',
  },
  Thigh_R_Posterior:{
    display: 'Thigh, Right, Posterior',
    code: 'Thigh_R_Posterior',
    area: '4.5',
  },
  Thigh_R_Medial:{
    display: 'Thigh, Right, Medial',
    code: 'Thigh_R_Medial',
    area: '4.5',
  },
  Thigh_R_Lateral:{
    display: 'Thigh, Right, Lateral',
    code: 'Thigh_R_Lateral',
    area: '4.5',
  },
  Thigh_L_Anterior:{
    display: 'Thigh, Left, Anterior',
    code: 'Thigh_L_Anterior',
    area: '4.5',
  },
  Thigh_L_Posterior:{
    display: 'Thigh, Left, Posterior',
    code: 'Thigh_L_Posterior',
    area: '4.5',
  },
  Thigh_L_Medial:{
    display: 'Thigh, Left, Medial',
    code: 'Thigh_L_Medial',
    area: '4.5',
  },
  Thigh_L_Lateral:{
    display: 'Thigh, Left, Lateral',
    code: 'Thigh_L_Lateral',
    area: '4.5',
  },
  Calf_R_Anterior:{
    display: 'Calf, Right, Anterior',
    code: 'Calf_R_Anterior',
    area: '3.25',
  },
  Calf_R_Posterior:{
    display: 'Calf, Right, Posterior',
    code: 'Calf_R_Posterior',
    area: '3.25',
  },
  Calf_R_Medial:{
    display: 'Calf, Right, Medial',
    code: 'Calf_R_Medial',
    area: '3.25',
  },
  Calf_R_Lateral:{
    display: 'Calf, Right, Lateral',
    code: 'Calf_R_Lateral',
    area: '3.25',
  },
  Calf_L_Anterior:{
    display: 'Calf, Left, Anterior',
    code: 'Calf_L_Anterior',
    area: '3.25',
  },
  Calf_L_Posterior:{
    display: 'Calf, Left, Posterior',
    code: 'Calf_L_Posterior',
    area: '3.25',
  },
  Calf_L_Medial:{
    display: 'Calf, Left, Medial',
    code: 'Calf_L_Medial',
    area: '3.25',
  },
  Calf_L_Lateral:{
    display: 'Calf, Left, Lateral',
    code: 'Calf_L_Lateral',
    area: '3.25',
  },
};
const lundBrowderObj = {
  ages: {
    infant: {
      key: 'infant',
      label: 'Infant (0-1)',
      start: 0,
      end: 1,
    },
    toddler: {
      key: 'toddler',
      label: 'Toddler (1-5)',
      start: 1,
      end: 5,
    },
    child: {
      key: 'child',
      label: 'Child (5-10)',
      start: 5,
      end: 10,
    },
    teenager: {
      key: 'teenager',
      label: 'Teenager (10-15)',
      start: 10,
      end: 15,
    },
    adult: {
      key: 'adult',
      label: 'Adult (15+)',
      start: 15,
    },
  },
  infant: { ...lundBrowderBase, ...infant },
  toddler: { ...lundBrowderBase, ...toddler },
  child: { ...lundBrowderBase, ...child },
  teenager: { ...lundBrowderBase, ...teenager },
  adult: { ...lundBrowderBase, ...adult },
};
exports.lundBrowderObj = lundBrowderObj;